import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export async function fetchPartNumberAvailability(partNumber: string) {
  const response = await occFetch(occUrl("/cad/partNumberAvailability"), {
    body: JSON.stringify({ partNumber }),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });

  return response.json();
}
